module.exports = __webpack_public_path__ + "img/Icon_Tiktok.cea6f0ae.svg";